/**
 * 테마 카드 처리 — 테두리 · 그림자를 테마 변수에서 받는다(lib/palette CARDS: 평면 · 선 · 만화 칸 · 스티커 · 발광 · 떠 있음 · 점선).
 * 기본(테마 없음)은 테두리 · 그림자 없음. 홈 카드 · 배너 · 이어하기 · 공지 줄처럼 "카드"로 읽히는 곳에 붙인다.
 * 찍힌 그림자(4px)가 잘리지 않게 감싸는 가로 줄에는 아래 여백을 조금 둔다.
 */
export const CARD_FX =
  '[border:var(--card-border,0_solid_transparent)] [box-shadow:var(--card-shadow,none)]'
